<mat-card appearance="outlined">
  <cotecna-file-upload
    id="fileUploadComponent"
    [options]="fileUploadOptions"
    (filesSelected)="onFilesSelected($event)"
    >
  </cotecna-file-upload>
  <table width="100%">
    @if (showContentTypeWarning) {
      <tr>
        <div class="alert-warning">
          <p>
            <mat-icon class="alert-warning-icon">warning</mat-icon> For the files
            that were not uploaded, only the following extensions are allowed:
          </p>
          <ul>
            <li>
              With 200MB limitation: .doc, .docx, .xls, .xlsx, .ppt, .pptx,
              .accdb, .pub, .xps, .pdf, .jpg, .jpeg, .png, .raw<br />
            </li>
          </ul>
          <ul>
            <li>
              With 1GB limitation: .mpg, .mpg2, .mpeg, .mpe, .mp4, .avi, .wmv,
              .mov, .rar, .zip <br />
            </li>
          </ul>
        </div>
      </tr>
    }
    @if (showUploadDocumentError) {
      <tr>
        <div class="show-error">
          <p>
            <mat-icon class="alert-warning-icon">error</mat-icon> An error has
            occurred while uploading the documents.
          </p>
        </div>
      </tr>
    }
    <tr class="button-container">
      @if (readyLoading) {
        <div>
          <button id="cancel-file-upload" (click)="cancel()" mat-button>
            CANCEL
          </button>
          <button
            id="submit-files"
            [disabled]="submitButtonDisabled"
            (click)="submit()"
            mat-button
            >
            UPLOAD FILES
          </button>
        </div>
      } @else {
        <mat-spinner class="loading-spinner" diameter="32"></mat-spinner>
      }
    </tr>
  </table>

</mat-card>
